export const SHOP_DAY_OFF_SELECTION = `
    id
    shop {id}
    date
    value
    createdAt
    updatedAt
`;
